import styled from "styled-components";

export const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Upload = styled.div`
  width: 50%;
  @media screen and (max-width: 590px) {
    margin-top: 16px;
  }
`;

export const UploadWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${Upload} {
    width: calc(50% - 16px);
    @media screen and (max-width: 590px) {
      width: 100%;
    }
  }

  @media screen and (max-width: 590px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Text = styled.div`
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  color: ${(props) => props.theme.colors.secondary};

  &.specifications {
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.colors.body};
  }
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const Images = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 80px;
`;


export const BodyContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 24px 82px 0 80px;

    @media only screen and (max-width: 1050px){
        padding: 12px 60px 0 60px;
    }

    @media only screen and (max-width: 768px){
        padding: 12px 45px 0 30px;
    }
`;

export const ItemContainer = styled.div`
    display: flex;
    width: 100%;
    margin-top: 68px;

    @media only screen and (max-width: 1400px){
        margin-top: 0;
    }

    @media only screen and (max-width: 1300px){
        margin-top: 20px;
        width: 100%;
    }

    @media only screen and (max-width: 1050px){
        display: flex;
        flex-direction: column;
        margin-bottom: 26px;
    }
`;

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    width: 15%;
    height: 40px;
    margin-top: 40px;

    @media only screen and (max-width: 1050px){
        width: 100%;
    }
`;

export const ComponentsUploadDesktopContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin-top: 40px;

    @media only screen and (max-width: 1600px){
        width: 100%;
    }

    @media only screen and (max-width: 1400px){
        flex-direction: column;
        width: 100%;
    }

    @media only screen and (max-width: 1050px){
        margin-top: 16px;
    }
`;

export const ComponentsUploadMobileContainer = styled.div`
    display: flex;  
    justify-content: space-between;
    width: 77%;
    margin-top: 40px;

    @media only screen and (max-width: 1600px){
        width: 100%;
    }

    @media only screen and (max-width: 1400px){
        flex-direction: column;
        width: 90%;
    }

    @media only screen and (max-width: 1050px){
        margin-top: 16px;
    }
`;